import { useEffect, useState } from 'react'
import { router } from '@inertiajs/react'
import { useShared } from '../lib/hooks'

// Top promo bar for the 15%-off-first-order newsletter offer. State + percent
// come from shared `promo` props (server decides eligibility); dismissal is
// remembered per-state in localStorage so a new state (e.g. after subscribing)
// can surface again.
export default function PromoBar() {
  const { promo } = useShared()
  const key = promo.active ? `promo_dismissed_${promo.state}` : ''
  // Visible by default (matches SSR — no flash-in, no hydration mismatch); the
  // effect hides it only if this state was previously dismissed.
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (!promo.active) return
    try {
      if (window.localStorage.getItem(key) === '1') setDismissed(true)
    } catch {
      /* ignore */
    }
  }, [key, promo.active])

  if (!promo.active || dismissed) return null

  const pct = promo.percent ?? 15

  function dismiss() {
    try {
      window.localStorage.setItem(key, '1')
    } catch {
      /* ignore */
    }
    setDismissed(true)
  }

  function subscribe() {
    router.post('/newsletter/subscribe', {}, { preserveScroll: true })
  }

  return (
    <div className="relative bg-paper text-ink">
      <div className="mx-auto max-w-[1400px] px-10 sm:px-12 py-2 flex items-center justify-center text-center">
        <p className="text-[13px] leading-snug font-medium tracking-tight">
          {promo.state === 'eligible' ? (
            <>Your <strong>{pct}% welcome discount</strong> is active — it&apos;s applied automatically at checkout.</>
          ) : promo.state === 'subscribe' ? (
            <>
              Subscribe to the newsletter and take <strong>{pct}% off</strong> your first order.{' '}
              <button
                type="button"
                onClick={subscribe}
                className="underline underline-offset-2 font-semibold hover:opacity-70 transition-opacity"
              >
                Subscribe →
              </button>
            </>
          ) : (
            <>
              Get <strong>{pct}% off</strong> your first order when you join the newsletter.{' '}
              <a
                href="/register"
                className="underline underline-offset-2 font-semibold hover:opacity-70 transition-opacity"
              >
                Sign up →
              </a>
            </>
          )}
        </p>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 size-6 grid place-items-center text-ink/50 hover:text-ink transition-colors"
      >
        <svg viewBox="0 0 16 16" className="size-3.5" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M2 2l12 12M14 2L2 14" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  )
}
